
import React from 'react';
import { Card } from '@/components/ui/card';
import { ValidationError } from '@/utils/cycle-tracking/types';
import TemplateDownloadStep from '../steps/TemplateDownloadStep';
import FileUploadStep from '../steps/FileUploadStep';
import ValidationAlerts from '../validations/ValidationAlerts';
import ImportStep from '../steps/ImportStep';

interface FileUploadSectionProps {
  file: File | null;
  fileInputRef: React.RefObject<HTMLInputElement>;
  isValidating: boolean;
  isUploading: boolean;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onReset: () => void;
  onImport: () => void;
  hasParsedData: boolean;
  hasErrors: boolean;
  errors: ValidationError[];
  warnings: ValidationError[];
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  file,
  fileInputRef,
  isValidating,
  isUploading,
  onFileChange,
  onReset,
  onImport,
  hasParsedData,
  hasErrors,
  errors,
  warnings
}) => {
  return (
    <Card className="p-6">
      <TemplateDownloadStep isDisabled={isValidating || isUploading} />
      
      <FileUploadStep 
        fileInputRef={fileInputRef}
        file={file}
        isDisabled={isValidating || isUploading}
        onReset={onReset}
      />
      
      <input
        type="file"
        accept=".xlsx,.csv"
        className="hidden"
        ref={fileInputRef}
        onChange={onFileChange}
        disabled={isValidating || isUploading}
      />
      
      <ValidationAlerts 
        errors={errors} 
        warnings={warnings} 
        parsedData={hasParsedData ? [{}] : []} // Just need length check
      />
      
      <ImportStep 
        hasParsedData={hasParsedData}
        hasErrors={hasErrors}
        isDisabled={isValidating}
        isUploading={isUploading}
        onImport={onImport}
      />
    </Card>
  );
};

export default FileUploadSection;
